import * as React from "react";
import { Table, Container, Alert } from "react-bootstrap";

export default function Overview({accountInfo}) {
    return(
        <Container>
                <Alert variant="danger">The Price API is not really working well.</Alert>

            <Table striped bordered hover variant="dark" size="sm">
            <tbody>
                <tr>
                <th>Address</th>
                <td>{accountInfo.address}</td>
                </tr>
                <tr>
                <td>Balance</td>
                <td>{(accountInfo.balance/1000000000).toFixed(2)} SMH</td>
                </tr>
                <tr>
                <td>Rewards Earned</td>
                <td>{(accountInfo.totalRewards/1000000000).toFixed(2)} SMH</td>
                </tr>
                <tr>
                <td>Account Value</td>
                <td>{(accountInfo.usdValue).toFixed(2)}</td>
                </tr>
                <tr>
                <td>Transaction Count</td>
                <td>{accountInfo.numberOfTransactions}</td>
                </tr>
                <tr>
                <td>Reward Count</td>
                <td>{accountInfo.numberOfRewards}</td>
                </tr>
            </tbody>
            </Table>
        </Container>
    )
}